import { useMutation } from 'react-query';
import { saveUserRole } from '../../services/user.service';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export default () => useMutation<any, void, any, void>(({ code, freeText }) => saveUserRole({ code, freeText }));
